import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';

import type { RecentsResourceType } from 'modules/recents/types/Recents.type';

import './influencer-modal-actions-menu-empty.scss';

applyTranslations(require('./influencer-modal-actions-menu-empty.i18n.json'));

const MSG_KEY = 'influencer_modal_actions_menu_empty';

type Props = {
  resourceType: RecentsResourceType
};

const InfluencerModalActionsMenuEmpty = (
  {
    resourceType
  }: Props
): JSX.Element => (
  <div className="influencer-modal-actions-menu-empty">
    {__t(`${MSG_KEY}.empty.${resourceType}`)}
  </div>
);

export default InfluencerModalActionsMenuEmpty;
